import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created");
      nav("/dashboard");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  const upd = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  return (
    <div className="max-w-md mx-auto px-6 py-20 md:py-28">
      <h1 className="font-display text-4xl tracking-tight">Create account</h1>
      <p className="text-muted-foreground mt-3">Register to book full journeys, save pets, and track delivery.</p>

      <Card className="mt-10 p-8 border-border">
        <form onSubmit={onSubmit} className="space-y-5" data-testid="register-form">
          <div>
            <Label className="text-xs uppercase tracking-wider text-muted-foreground">Full name</Label>
            <Input required value={form.name} onChange={(e) => upd("name", e.target.value)} data-testid="register-name-input" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-muted-foreground">Email</Label>
            <Input required type="email" value={form.email} onChange={(e) => upd("email", e.target.value)} data-testid="register-email-input" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-muted-foreground">Phone (optional)</Label>
            <Input value={form.phone} onChange={(e) => upd("phone", e.target.value)} data-testid="register-phone-input" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-muted-foreground">Password</Label>
            <Input required type="password" value={form.password} onChange={(e) => upd("password", e.target.value)} data-testid="register-password-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-12" data-testid="register-submit-btn">
            {loading ? "Creating..." : "Create account"}
          </Button>
        </form>
      </Card>

      <p className="text-sm text-muted-foreground mt-6 text-center">
        Already have an account? <Link to="/login" className="text-foreground underline underline-offset-4">Sign in</Link>
      </p>
    </div>
  );
}
